import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-api-load-error',
  standalone: true,
  templateUrl: './api-load-error.component.html',
  styleUrl: './api-load-error.component.scss',
})
export class ApiLoadErrorComponent {
  @Input() title = 'Something went wrong';
  @Input() message = "We couldn't load this data right now. Please try again.";
  @Input() retryLabel = 'Retry';

  @Output() retry = new EventEmitter<void>();

  onRetry(): void {
    this.retry.emit();
  }
}
